<template>
    <div>
        <div class="text-center">
            <h2>เพิ่มบัญชีย่อย</h2>
            <br/>
            <b-row sm="10" v-if="form_details.id">
                <b-col sm="4" class="col text-right">
                    <label>รหัสบัญชี</label>
                </b-col>
                <b-col sm="6">
                    <input v-model="form_details.account_full"
                           disabled
                           class="form-control"
                           type="text"/></b-col>
            </b-row>
            <br/>
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>ชื่อบัญชีย่อย</label>
                </b-col>
                <b-col sm="6">
                    <input v-model="form_details.name"
                           class="form-control"
                           type="text"/></b-col>
            </b-row>
        </div>
        <br/>
        <div class="col text-center">
            <button type="button"
                    @click="submitDetails"
                    :disabled="!form_details.name"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp&nbsp
            <button type="button"
                    @click="cancelDetails"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "add-account-details-modal",
        created(){

        },
        data(){
            return{

            }
        },
        computed:{
            ...mapState({
                form_details:state=>{
                    return state.Account.accountDetailsForm;
                }
            })
        },
        methods:{
            submitDetails(){

                this.$emit("submit",this.form_details);
            },
            cancelDetails(){
                this.$emit("submit",false);
            }
        }
    }
</script>

<style scoped>

</style>